import NotiFicationSet from '@/views/set/NotiFicationSet'
import DashboardSet from '@/views/set/DashboardSet'
import MyCstmrRegSet from '@/views/set/MyCstmrRegSet'
import Tutorial from '@/views/set/Tutorial'
export default [
    {
        path: '/set/notificationSet',
        name: 'notification-set',
        component: NotiFicationSet,
        meta: { 
            auth: true,
            logging: true,
            pageName: '알림설정',
        }
    },
    {
        path: '/set/dashboardSet',
        name: 'dashboard-set',
        component: DashboardSet,
        meta: { 
            auth: true,
            logging: true,
            pageName: '홈 편집',
        }
    },
    {
        path: '/set/myCstmrRegSet',
        name: 'my-cstmr-reg-set',
        component: MyCstmrRegSet,
        meta: { 
            auth: true,
            logging: true,
            pageName: '고객등록 편집',
        }
    },
    {
        path: '/set/tutorial',
        name: 'tutorial',
        component: Tutorial,
        meta: { 
            auth: false,
            logging: true,
            pageName: '튜토리얼',
        }
    },
]